import { createContext, useContext, useState } from "react";

const AdminLayoutContext = createContext();

const AdminLayoutProvider = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <AdminLayoutContext.Provider value={{ openSidebar, setOpenSidebar }}>
      {children}
    </AdminLayoutContext.Provider>
  );
};

export default AdminLayoutProvider;

export const useAdminLayoutContext = () => {
  const context = useContext(AdminLayoutContext);
  if (!context) {
    throw new Error(
      'Error: use "useAdminLayoutContext" inside "AdminLayoutProvider" '
    );
  }
  return context;
};
